/*global angular*/
'use strict';

angular.module('MrDWebApp').controller('HomeCtrl', function ($scope, $timeout, $window) {

  var _hc = this;

  $scope._rc.bodyClass = 'html-home';

  $scope._rc.track('home_page', 'view_landing_screen');

  var testimonials_wrap = document.getElementById('testimonials');
  if (testimonials_wrap !== null) {
    for (var i = testimonials_wrap.children.length; i >= 0; i--) {
      testimonials_wrap.appendChild(testimonials_wrap.children[Math.random() * i | 0]);
    }
    testimonials_wrap.children[0].style.display = 'inline-block';
    testimonials_wrap.children[1].style.display = 'inline-block';
    testimonials_wrap.children[2].style.display = 'inline-block';
  }

  _hc.footerOrderClick = function () {
    $window.scroll(0, 0);
  };

  $scope.expand = function(obj) {
    if ($window.innerWidth < 700) {
      var ul = obj.target.parentElement.querySelectorAll('ul')[0];
      if (typeof ul === 'undefined'){
        ul = obj.target.parentElement.parentElement.querySelectorAll('ul')[0];
      }
      if (ul.offsetHeight > 0) {
        ul.style.display = 'none';
      } else {
        ul.style.display = 'inline-block';
      }
    }
  };

  $scope.howitworksNext = function () {
    document.querySelector('.howitworksSwiper').swiper.slideNext();
  };

  $scope.howitworksPrev = function () {
    document.querySelector('.howitworksSwiper').swiper.slidePrev();
  };

  $scope.brandsNext = function () {
    document.querySelector('.brandsSwiper').swiper.slideNext();
  };

  $scope.brandsPrev = function () {
    document.querySelector('.brandsSwiper').swiper.slidePrev();
  };

  $scope.linksNext = function () {
    document.querySelector('.linksSwiper').swiper.slideNext();
  };

  $scope.linksPrev = function () {
    document.querySelector('.linksSwiper').swiper.slidePrev();
  };

  $scope.testimonialNext = function () {
    document.querySelector('.testimonialSwiper').swiper.slideNext();
  };

  $scope.testimonialPrev = function () {
    document.querySelector('.testimonialSwiper').swiper.slidePrev();
  };
});
